import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CxAbstractComponent } from '@b2b/components/cms/cx-abstract/cx-abstract-component/cx-abstract.component';
import { SearchableComponent } from '@b2b/components/searchable/searchable.component';
import { CmsComponentPipe } from '@app/b2b/core/cms/pipes/cms-component.pipe';
import { CmsComponent, CX_COMPONENT } from '@app/core/models/atomics.model';
import { LanguageSelectorModule } from '@b2b/features/misc/language-selector/language-selector.module';
import { B2BUnitService } from '@b2b/features/b2b-unit/core/b2b-unit.service';
import { B2BUnit } from '@b2b/features/b2b-unit/core/b2b-unit.model';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';
import { MiniCartComponent } from '@b2b/components/cms/sections/cx-header-section/components/mini-cart/mini-cart.component';

@Component({
  selector: 'header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrl: './header-desktop.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    LanguageSelectorModule,
    MiniCartComponent,
    SearchableComponent,
    CxAbstractComponent,
    CmsComponentPipe,
  ],
})
export class HeaderDesktopComponent {
  @Input({ required: true }) components!: CmsComponent[];

  CX_COMPONENT = CX_COMPONENT;

  // Current B2B unit from store
  currentB2bUnit$: Observable<B2BUnit | null>;

  constructor(private b2bUnitService: B2BUnitService) {
    this.currentB2bUnit$ = this.b2bUnitService.getCurrentB2BUnit().pipe(map(state => state.data));
  }

  /**
   * Opens the B2B unit selection modal.
   * User can search and select a different B2B unit.
   */
  openB2bUnitSelectionModal(): void {
    this.b2bUnitService.showSelectionModal();
  }
}
